import { useTranslation } from "react-i18next";
import Button from "../../Button/Button";
import useOnClickFunctions from "../helpers/onClickFunctions";
import { useParams } from "react-router-dom";

function PayOrSplitBill() {
  const { t } = useTranslation();
  const { handleNavigate } = useOnClickFunctions();
  const { restaurantId, tableId } = useParams();

  return (
    <Button
      onClick={() =>
        handleNavigate(
          `/restaurants/${restaurantId}/tables/${tableId}/pay-your-bill`,
        )
      }
      label={t("transparentDrawer.button.payOrSplitTheBill")}
      variant="contained"
      color="primary"
      maxWidth
      mobile={true}
    />
  );
}

export default PayOrSplitBill;
